import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-delete-text-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './delete-text-modal.component.html',
  styleUrl: './delete-text-modal.component.css'
})
export class DeleteTextModalComponent {
  @Input() title: string = 'Delete Item';
  @Input() message: string = 'Are you sure you want to delete this item?';
  @Input() itemName?: string;
  @Output() deleteConfirmed = new EventEmitter<void>();

  constructor(public activeModal: NgbActiveModal) {}

  onCancel(): void { this.activeModal.dismiss(); }

  onDelete(): void { this.deleteConfirmed.emit(); }
}


